/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'envelop': {
    width: 16,
    height: 14,
    viewBox: '0 0 16 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M.01 2.769C.005 2.845 0 2.922 0 3v7.667a2.5 2.5 0 002.5 2.5h11a2.5 2.5 0 002.5-2.5V3c0-.078-.004-.155-.01-.231a.499.499 0 00-.06-.357A2.501 2.501 0 0013.5.5h-11A2.501 2.501 0 00.07 2.412a.498.498 0 00-.06.357zM1 3.6v7.066a1.5 1.5 0 001.5 1.5h11a1.5 1.5 0 001.5-1.5V3.6L8.277 8.083a.5.5 0 01-.554 0L1 3.6zm13.902-1.136A1.5 1.5 0 0013.5 1.5h-11a1.5 1.5 0 00-1.402.965L8 7.065l6.902-4.6z" _fill="#1F222C"/>'
  }
})
